const Resume = () => {
  return (
    <div className="container h-full">
      <iframe
        title="Joseph Insalaco Resume"
        src="https://drive.google.com/file/d/1qCvVZVbVNmcCtf19baIBBOxXCRNSXxq9/preview"
        style={{ width: '100%', height: '90vh' }}
        allow="autoplay"
      ></iframe>
    </div>
  );
};

export default Resume;
